export default __webpack_public_path__ + "static/cs-solution-architecture--mobile-7a83a7893c1976e1db7d19d6248c3b49.webp";